import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en, it } from "@igloocloud/igloosharedui/locales";

i18n.use(initReactI18next).init({
  resources: {
    en,
    it,
  },
  lng:
    localStorage.getItem("language") ||
    (navigator.language || navigator.userLanguage).slice(0, 2),
  fallbackLng: "en",
  debug: false,
  ns: ["translations"],
  defaultNS: "translations",
  interpolation: {
    escapeValue: false,
    formatSeparator: ",",
  },
  react: {
    wait: true,
    bindI18n: "languageChanged loaded",
    bindStore: "added removed",
    nsMode: "default",
  },
});

export default i18n;
